module.exports = __webpack_public_path__ + "static/media/kids_36.494d1129.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_36.jpg
// module id = 5892
// module chunks = 0